'use strict';

var StepEntitiesAndControlTypeDirective = function StepEntitiesAndControlTypeDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-entities-and-control-type.html'),
    controller: 'StepEntitiesAndControlTypeController',
    link: function link(scope, element) {
      var modalEl = element.find('#new-entity-modal');
      scope.showCreateEntityDialog = function () {
        modalEl.modal('show');
      };
      scope.hideCreateEntryDialog = function () {
        modalEl.modal('hide');
      };
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
    }
  };
};
StepEntitiesAndControlTypeDirective.$inject = [];
module.exports = StepEntitiesAndControlTypeDirective;